import { render, staticRenderFns } from "./FeaturedBannersFormPage.vue?vue&type=template&id=2c3c3a26&"
import script from "./FeaturedBannersFormPage.vue?vue&type=script&lang=js&"
export * from "./FeaturedBannersFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports